<div class="dark-theme meditation-container">
    <div class="container-fluid h-100" *ngIf="currentIndex == 0">
        <div class="row h-100">
            <div class="col-12 offset-md-3 col-md-6 offset-lg-4 col-lg-4 py-4 py-lg-5">
                <div class="d-flex flex-column h-100 justify-content-center">
                    <div class="meditation-intro text-center row">
                        <div class="col-12">
                            This exercise requires self-reflection, honesty, and vulnerability so before we begin...
                        </div>
                        <div class="col-12 text-xlarge pt-3">
                            Give yourself space and time to be present.
                        </div>
                    </div>
                    <div class="meditation-exercise d-flex flex-column align-items-center justify-content-center py-5">
                        <div class="pb-4">Start by taking 3 breaths</div>
                        <div class="meditation-exercise-anim">

                            <div class="meditation-animation">
                                <div class="orbit">
                                    <div class="spinner"></div>
                                </div>
                                <div class="meditation-animation-step"></div>
                                <div class="meditation-animation-step-content inhale">INHALE</div>
                                <div class="meditation-animation-step-content exhale">EXHALE</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="meditation-questions" *ngIf="currentIndex >= 1">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12 text-left text-md-center py-4">Now let’s check in on where you are and how you are
                    doing.</div>
            </div>
        </div>
        <div [ngClass]="{'focus' : currentIndex == 1, 'meditation-question': true}">
            <div class="container-fluid py-4">
                <div class="row">
                    <div class="col-12 offset-md-3 col-md-6 offset-lg-4 col-lg-4 subtitle">What are your surroundings?
                    </div>
                </div>
                <div class="row pt-2">
                    <div class="col-12 offset-md-3 col-md-6 offset-lg-4 col-lg-4">
                        <textarea rows="2" type="text" class="form-control text-xlarge" (keyup)="change($event, 1)"
                            placeholder="What do you see to your left and right?"></textarea>
                    </div>
                </div>
            </div>
        </div>
        <div class="container-fluid" *ngIf="currentIndex >= 2">
            <div class="row">
                <div class="col-12 text-center py-4">How are you feeling...</div>
            </div>
        </div>
        <div *ngIf="currentIndex >= 2 " class="meditation-feeling">
            <div class="container-fluid px-lg-5">
                <div class="row  meditation-feeling-questions">
                    <div [ngClass]="{'focus' : currentIndex == 2, 'col-12 col-lg-3 meditation-feeling-question': true}">
                        <div class="row p-4">
                            <div class="col-12 subtitle">Physically?</div>
                            <div class="col-12">
                                <textarea rows="2" type="text" (keyup)="change($event, 2)"
                                    [ngClass]="{'d-none d-lg-block' : (currentIndex != 2 && !steps[2].value), 'form-control text-xlarge': true}"
                                    placeholder="How does your body feel?"></textarea>
                            </div>
                        </div>
                    </div>
                    <div
                        [ngClass]="{'focus' : currentIndex == 2 || currentIndex == 3, 'col-12 col-lg-3 meditation-feeling-question': true}">
                        <div class="row p-4">
                            <div class="col-12 subtitle">Intellectually?</div>
                            <div class="col-12">
                                <textarea rows="2" type="text" (keyup)="change($event, 3)"
                                    [ngClass]="{'d-none d-lg-block' : (currentIndex != 3 && !steps[3].value), 'form-control text-xlarge': true}"
                                    placeholder="What are you thinking about?"></textarea>
                            </div>
                        </div>
                    </div>
                    <div
                        [ngClass]="{'focus' : currentIndex == 3 || currentIndex == 4, 'col-12 col-lg-3 meditation-feeling-question': true}">
                        <div class="row p-4">
                            <div class="col-12 subtitle">Emotionally?</div>
                            <div class="col-12">
                                <textarea rows="2" type="text" (keyup)="change($event, 4)"
                                    [ngClass]="{'d-none d-lg-block' : (currentIndex != 4 && !steps[4].value), 'form-control text-xlarge': true}"
                                    placeholder="Describe the emotion(s) you're feeling."></textarea>
                            </div>
                        </div>
                    </div>
                    <div
                        [ngClass]="{'focus' : currentIndex == 4 || currentIndex == 5, 'col-12 col-lg-3 meditation-feeling-question': true}">
                        <div class="row p-4">
                            <div class="col-12 subtitle">Spiritually?</div>
                            <div class="col-12">
                                <textarea rows="2" type="text" (keyup)="change($event, 5)"
                                    [ngClass]="{'d-none d-lg-block' : (currentIndex != 5 && !steps[5].value), 'form-control text-xlarge': true}"
                                    placeholder="How aligned do you feel with your wellbeing?"></textarea>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container-fluid py-4 pt-lg-5" *ngIf="allAnswersDone">
            <div class="row">
                <div class="col-12 d-flex justify-content-center">
                    <button type="button" class="btn btn-primary col-10 col-lg-4" (click)="begin()">let's begin</button>
                </div>
            </div>
        </div>
    </div>
</div>